import type { RouteObject } from 'react-router';
import { PermissionGate } from '@saas/ui';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
export const assetRoutes: RouteObject[] = [
  {
    path: '/asset-register',
    lazy: async () => {
      const m = await import('./pages/AssetListPage.js');
      const Page = m.default;
      return { Component: () => <PermissionGate anyOf={['asset.item.read']}><Page /></PermissionGate> };
    },
  },
];
